import moment from 'moment';

export const getPediatricIndicator = (admission_date, birth_date) => {
  if (admission_date && birth_date) {
    const presentationDate = moment(admission_date);
    const birthDate = moment(birth_date);

    if (presentationDate.isValid() && birthDate.isValid()) {
      const age = presentationDate.diff(birthDate, 'years');
      return age < 18;
    }
  }
  return false;
};
